import React from 'react';
import { RecipeType } from '../../../../enums/RecipeType';
import { strings } from '../../../../resources/strings';
import { DiagnosticInformation } from '../../../../models/DiagnosticInformation';
import { MultifocalInfo } from '../../../../models/MultifocalInfo';
import { Field, FieldType } from '../../../../common-components/Field/Field';
import { If } from '../../../../common-components/If/If';
import { FormRecipeValues } from '../FormRecipeV2';
import { Diagnostic } from './Diagnostic/Diagnostic';
import { Container, MultifocalFields } from './styles';

interface ITabDiagnosticProps {
  values?: FormRecipeValues;
  change: (values: FormRecipeValues) => void;
}

const TabDiagnostic: React.FC<ITabDiagnosticProps> = ({
  values,
  change
}) => {

  const multifocalRecipeType = values?.recipeType == RecipeType.Bifocal;

  return (
    <Container>
      <Diagnostic
        typeDescription={strings.ToFar}
        values={values?.farDiagnostic}
        marginBottom='5px'
        change={(diagnostic) => changeDiagnostic('farDiagnostic', diagnostic)}
      />

      <Diagnostic
        typeDescription={strings.ToNear}
        values={values?.nearDiagnostic}
        marginBottom='10px'
        change={(diagnostic) => changeDiagnostic('nearDiagnostic', diagnostic)}
      />

      <If condition={multifocalRecipeType}>
        <MultifocalFields>
          <Field
            label={strings.Addition}
            type={FieldType.Text}
            value={values?.multifocalInfo?.addField}
            change={(value) => changeMultifocalValue('addField', value)}
            marginTop='0px' marginBottom='0px'
            width='23%'
          />
        </MultifocalFields>
      </If>
    </Container>
  );

  function changeDiagnostic(field: string, diagnostic: DiagnosticInformation) {
    if (!values) values = new FormRecipeValues();
    (values as any)[field] = diagnostic;
    change({ ...values });
  }

  function changeMultifocalValue(field: string, value: any) {
    if (!values) values = new FormRecipeValues();
    if (!values.multifocalInfo) values.multifocalInfo = new MultifocalInfo();
    (values.multifocalInfo as any)[field] = value;
    change({ ...values });
  }
}

export { TabDiagnostic };